import CardApply from "@/pages/cards/CardApplicationV2"

function GuideBuyCard() {
  return (
    <>
      <CardApply />
    </>
  )
}

export default GuideBuyCard
